import { DataItem } from 'scrivito'

import { HeaderTag } from './types'
import { Address } from '@/Data/Address/AddressDataClass'
import { AddressContactRelation } from '@/Data/AddressContactRelation/AddressContactRelationDataClass'
import { DataClassName } from '@/Data/const'
import { getDataItemAttributesFlatMap } from '@/utils/CRUD/read/dataItem/getDataItemMap'
import { FieldMap } from '@/utils/CRUD/read/dataItem/types'
import { getDataClassIcon } from '@/utils/image/getDataClassIcon'

export const getHeaderProps = (dataItem: DataItem) => {
  const fieldsMap = getDataItemAttributesFlatMap(dataItem)
  const dataClassName = dataItem.dataClassName()!
  const icon = getDataClassIcon(dataClassName)

  let subtitle: string | undefined = undefined
  let link: string | undefined = undefined
  let linkDataItem: DataItem | undefined = undefined
  let tags

  switch (dataClassName) {
    case DataClassName.ACTIVITY: {
      subtitle = fieldsMap?.['subType']?.displayValue as string

      const origin = fieldsMap?.['origin']
      const originDataItem = origin?.reference?.referenceDataItem
      if (originDataItem) {
        link =
          (origin?.displayValue as string | undefined) ||
          (originDataItem.get('displayTitle') as string | undefined)
        linkDataItem = originDataItem
      } else {
        link = fieldsMap?.['status']?.displayValue as string
      }

      tags = formatTags('Priority', fieldsMap?.['priority'])

      break
    }

    case DataClassName.PERSON: {
      subtitle = fieldsMap?.['position']?.displayValue as string

      const parent = fieldsMap?.['parent']
      const parentDataItem = parent?.reference?.referenceDataItem
      link = parent?.displayValue as string
      if (parentDataItem) {
        linkDataItem = parentDataItem
      }

      tags = formatTags('Status', fieldsMap?.['status'])

      break
    }

    case DataClassName.COMPANY: {
      subtitle = fieldsMap?.['industry']?.displayValue as string

      tags = formatTags('Status', fieldsMap?.['status'])

      const getAddressIdFromRelation = (relation: DataItem) =>
        relation.get('address') as string | null

      const addressRelations = AddressContactRelation.all()
        .transform({ filters: { contact: dataItem.id() } })
        .take()

      const addressIds = addressRelations.map(getAddressIdFromRelation)

      if (addressIds.length) {
        const mainAddress = Address.all()
          .transform({
            filters: { ids: addressIds.join(','), type: 'MAIN_ADDRESS' },
            limit: 1,
          })
          .take()[0]

        const firstAddressId = addressIds[0]
        const address =
          mainAddress ||
          (firstAddressId ? Address.get(firstAddressId) : undefined)
        const city = address?.get('city')
        const country = address?.get('country')
        const displayAddress = [city, country].filter((e) => e)
        link = displayAddress.join(', ')
      }

      break
    }

    case DataClassName.OPPORTUNITY:
    case DataClassName.QUOTE:
    case DataClassName.ORDER: {
      subtitle = fieldsMap?.['type']?.displayValue as string

      const customer = fieldsMap?.['customer']
      const customerDataItem = customer?.reference?.referenceDataItem
      link = customer?.displayValue as string
      if (customerDataItem) {
        linkDataItem = customerDataItem
      }

      tags = formatTags('Status', fieldsMap?.['status'])

      break
    }

    case DataClassName.TICKET: {
      subtitle = fieldsMap?.['number']?.displayValue as string

      const customer = fieldsMap?.['customer']
      const customerDataItem = customer?.reference?.referenceDataItem
      link = customer?.displayValue as string
      if (customerDataItem) {
        linkDataItem = customerDataItem
      }

      tags = formatTags('Status', fieldsMap?.['status'])

      break
    }

    case DataClassName.DOCUMENT: {
      subtitle = fieldsMap?.['type']?.displayValue as string

      const size = fieldsMap?.['size']?.displayValue
      if (size) {
        link = `${size} MB`
      }

      break
    }

    default:
      break
  }

  return { subtitle, link, linkDataItem, tags, icon }
}

const formatTags = (key: string, field?: FieldMap): HeaderTag[] | undefined => {
  if (!field?.displayValue) return

  const displayValues = Array.isArray(field.displayValue)
    ? field.displayValue
    : [field.displayValue]

  const rawValues = Array.isArray(field.value)
    ? field.value
    : field.value !== undefined && field.value !== null
      ? [field.value]
      : []

  const values = rawValues.length
    ? rawValues.map((rawValue, index) => {
        const enumValue = field.fieldSchema?.enumValues?.find(
          (option) => option.value === rawValue,
        )

        return {
          label: enumValue?.title ?? displayValues[index] ?? String(rawValue),
          enumGroup: enumValue?.data?.group,
        }
      })
    : displayValues.map((label) => ({ label }))

  return [{ key, values }]
}
